<div class="file-preview-container">
  @if (errorMessage) {
    <div class="error-message">
      <p>{{ errorMessage }}</p>
    </div>
  } @else if (data?.fileType === 'image' && previewUrl) {
    <img
      [src]="previewUrl"
      [alt]="data.filename"
      class="preview-image"
      (error)="handleImageError()">
  } @else if (previewUrl) {
    <iframe
      [src]="previewUrl"
      class="preview-iframe"
      frameborder="0">
    </iframe>
  } @else if (htmlContent) {
    <div class="html-preview" [innerHTML]="htmlContent"></div>
  }
</div>
